// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const BirthdatePhase = {
  "BEFORE": "BEFORE",
  "AFTER": "AFTER"
};

const { Tenant, District, Page, Announcement, Checklist, ChecklistItem, Info, Media, ChecklistMedia, UserSettings, UserCheckedChecklistItem, UserHiddenChecklistItem, Locale, ChecklistItemDate, ChecklistItemContentList, ChecklistItemContentDetail, BirthdateSettings } = initSchema(schema);

export {
  Tenant,
  District,
  Page,
  Announcement,
  Checklist,
  ChecklistItem,
  Info,
  Media,
  ChecklistMedia,
  UserSettings,
  UserCheckedChecklistItem,
  UserHiddenChecklistItem,
  BirthdatePhase,
  Locale,
  ChecklistItemDate,
  ChecklistItemContentList,
  ChecklistItemContentDetail,
  BirthdateSettings
};